import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Heading, Box, ResponsiveContext } from 'grommet';
import { PageSection, SectionBody } from './PageSection';
import { Button } from './Button';

const TitleContainer = styled(Box)`
  @media ${({ theme }) => theme.custom.layouts.above_large} {
    margin: 0 auto;
    width: calc((10 / 12) * 100%);
  }
`;

const StyledDemoBanner = styled(PageSection)`
  padding-top: 30px;
  padding-bottom: 30px;
  @media ${({ theme }) => theme.custom.layouts.above_medium} {
    padding-top: 80px;
    padding-bottom: 80px;
  }
  @media ${({ theme }) => theme.custom.layouts.above_medium} {
    padding-top: 90px;
    padding-bottom: 90px;
  }
`;

const DemoBanner = ({
  title,
  ctaLabel,
  ctaUrl,
  backgroundImageDesktop,
  backgroundImageMobile,
}) => {
  const layout = useContext(ResponsiveContext);
  const useMobileLayout = layout !== 'large';

  const [backgroundImage, setBackgroundImage] = useState(null);

  useEffect(() => {
    if (useMobileLayout) {
      setBackgroundImage(backgroundImageMobile.fixed.src);
    } else {
      setBackgroundImage(backgroundImageDesktop.fixed.src);
    }
  }, [useMobileLayout]);

  return (
    <StyledDemoBanner backgroundImage={backgroundImage}>
      <SectionBody>
        <TitleContainer pad={{ bottom: '30px' }}>
          <Heading color={'light-1'} textAlign="center" level="2">
            {title}
          </Heading>
        </TitleContainer>
        <Box direction="row" justify="center">
          <Button onDark label={ctaLabel} href={ctaUrl} />
        </Box>
      </SectionBody>
    </StyledDemoBanner>
  );
};

DemoBanner.propTypes = {
  title: PropTypes.string.isRequired,
  ctaLabel: PropTypes.string.isRequired,
  ctaUrl: PropTypes.string.isRequired,
  backgroundImage: PropTypes.object
};

export default DemoBanner;
